const BASE = '/tws.proxy/public/icons/forecastx';

const EXCHANGE_PRIORITY = ['FORECASTX', 'KALSHI', 'CME', 'POLYMARKET'] as const;

export function preferredProductConid(exchanges?: string[], productConids?: number[]): number | undefined {
  if (!exchanges?.length || !productConids?.length) return productConids?.[0];
  for (const target of EXCHANGE_PRIORITY) {
    const idx = exchanges.indexOf(target);
    if (idx !== -1 && productConids[idx] != null) return productConids[idx];
  }
  return productConids[0];
}

export function forecastIconUrl(params: { conid?: number; productConid?: number; category?: string }): string {
  const qs = new URLSearchParams();
  if (params.productConid != null) {
    qs.set('product_conid', String(params.productConid));
  }
  if (params.conid != null) {
    qs.set('conid', String(params.conid));
  }
  if (params.category) qs.set('category', params.category);
  return `${BASE}?${qs.toString()}`;
}
